import { View } from 'react-native';
import React from 'react';
import useCardStyle from './utils/useCardStyle';
const BMCard = (props) => {
    const { elevation, customStyle, layout, children, style, ...restProps } = props;
    const cardStyle = useCardStyle(elevation, layout);
    return (<View style={[style, cardStyle, customStyle]} {...restProps}>
      {children}
    </View>);
};
export default BMCard;
